<template>
	<div class="BaseShiftTable">
		<simplebar class="simplebar">
			<table class="tableMain">
				<thead>
					<tr>
						<th>
							Shift Name
						</th>
						<th>
							Start Time
						</th>
						<th>
							End Time
						</th>
						<!-- <th>
							Minimum Staff
						</th> -->
						<th>
							Delete
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in shifts" :key="index">
						<td>
							<BaseInput
								v-model="item.shift_name"
								v-validate="'required'"
								type="text"
								class="baseInput"
								style="width: 200px;"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Shift Name"
								:name="'shift_name' + index"
								@change="$emit('staffOpenPopUp')"
							/>
							<p>
								<span
									:v-show="errors.has('shift_name' + index)"
									class=" text-red-dark text-xs"
								>
									{{ errors.first("shift_name" + index) }}
								</span>
							</p>
						</td>
						<td>
							<!-- <el-time-picker
								v-model="item.shift_start_time"
								v-validate="'required'"
								style="width: 130px;"
								format="HH:mm"
								value-format="HH:mm"
								:name="'shift_start_time' + index"
								placeholder="Start Time"
								@change="$emit('staffOpenPopUp')"
							>
							</el-time-picker> -->
							<el-time-select
								v-model="item.shift_start_time"
								v-validate="'required'"
								style="width: 130px;"
								:picker-options="{
									start: '00:00',
									step: '00:15',
									end: '23:59'
								}"
								placeholder="Hrs::Mins"
								:name="'shift_start_time' + index"
								@change="$emit('staffOpenPopUp')"
							>
							</el-time-select>
							<p>
								<span
									:v-show="errors.has('shift_start_time' + index)"
									class=" text-red-dark text-xs"
								>
									{{ errors.first("shift_start_time" + index) }}
								</span>
							</p>
						</td>
						<td>
							<el-time-select
								v-model="item.shift_end_time"
								v-validate="'required'"
								style="width: 130px;"
								:picker-options="{
									start: '00:00',
									step: '00:15',
									end: '23:59'
								}"
								placeholder="Hrs::Mins"
								:name="'shift_end_time' + index"
								@change="$emit('staffOpenPopUp')"
							>
							</el-time-select>
							<p>
								<span
									:v-show="errors.has('shift_end_time' + index)"
									class=" text-red-dark text-xs"
								>
									{{ errors.first("shift_end_time" + index) }}
								</span>
							</p>
						</td>
						<!-- <td>
							<BaseInput
								v-model="item.min_staff_required"
								v-validate="'required'"
								class="baseInput"
								style="width: 100%;"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Minimum Staff"
								:name="'min_staff_required' + index"
								@change="$emit('staffOpenPopUp')"
							/>
							<p>
								<span
									:v-show="errors.has('min_staff_required' + index)"
									class=" text-red-dark text-xs"
								>
									{{ errors.first("min_staff_required" + index) }}
								</span>
							</p>
						</td> -->
						<td>
							<img
								class="p-2 cursor-pointer"
								src="../../../../../../assets/images/delete-icon.png"
								alt=""
								@click="deleteShift(item.id, index)"
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</simplebar>
		<div class="p-2" style="width: 6rem;">
			<BaseButton
				type="submit"
				buttonclass="btn p-2 text-xs"
				@click="addShiftList"
			>
				Add Shift
			</BaseButton>
		</div>
	</div>
</template>
<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import LabourPalnningService from "../../../../../../services/labourPalnningService";
export default {
	name: "BaseShiftTable",
	components: {
		simplebar
	},
	inject: ["$validator"],
	props: {
		shifts: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {};
	},
	methods: {
		addShiftList() {
			this.shifts.push({
				min_staff_required: null,
				shift_end_time: null,
				shift_name: "",
				shift_start_time: null
			});
		},
		deleteShift(id, index) {
			console.log(id, index);
			if (id != null && index != 0) {
				var data = {
					id: id
				};
				LabourPalnningService.deleteShiftDetails(data).then(response => {
					if (response.status == 204) {
						this.shifts.splice(index, 1);
					}
				});
			} else if (this.shifts.length > 1) {
				this.shifts.splice(index, 1);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import "./BaseShiftTable.scss";
</style>
